import type { TextComposerExtension } from "../editor/extensionContract";
import { ctaExtension } from "./cta/ctaExtension";
import { mediaExtension } from "./media/mediaExtension";
import { mergeTagExtension } from "./mergeTags/mergeTagExtension";
import { offerExtension } from "./offers/offerExtension";
import { suggestedActionsExtension } from "./suggestedActions/suggestedActionsExtension";

/**
 * Default extension set registered by `MessageDraftProvider`.
 *
 * This is also the composer's section render order — suggested actions lead.
 * It doesn't affect merge-tag resolution: `mergeTags.transformRcs` only
 * rewrites body text, not the `suggestions`/`buttons` arrays, so each extension
 * resolves its own aliases. What still matters is that `mergeTags` precedes
 * offers/CTA/media so their body-text contributions land after resolution.
 */
export const defaultExtensions: TextComposerExtension[] = [
  suggestedActionsExtension,
  mergeTagExtension,
  offerExtension,
  ctaExtension,
  mediaExtension,
];
